<template>
  <div class="sidebar" id="sidebar" style="z-index: 2" :style="{width:sideBarWidth}">
    <nav class="sidebar-nav" :style="{width:barWidth}">
      <sidebar-item :routes='siderbar_routers.children'></sidebar-item>
    </nav>
  </div>
</template>
<script>
   import SidebarItem from './SidebarItem';
import { mapGetters } from 'vuex';
export default {
  name: 'sidebar',
  components: { SidebarItem },
      computed: {
        ...mapGetters([
          'siderbar_routers'
        ])
      },
  data(){
    return{
      barWidth:"210",
      sideBarWidth:"210",
    }
  },
  created(){
    console.log(this.siderbar_routers,'$')
    window.addEventListener('resize', this.handleResize)
  },
  mounted(){
    this.initSidebar();
  },
  methods: {
    handleClick (e) {
      e.preventDefault()
      e.target.parentElement.classList.toggle('open')
    },
    initSidebar(){
      const  width = document.body.clientWidth ||document.body.scrollWidth;
      const big = this.$store.getters.sidebarBigWidth;
      const small = this.$store.getters.sidebarSmallWidth;
      const critical = this.$store.getters.sidebarCriticalValue;
      if(width > critical){
        this.barWidth = big-10+"px";
        this.sideBarWidth = big-10+"px";
      }else {
        this.barWidth = small+"px";
        this.sideBarWidth = small+"px";
      }
    },
    handleResize(){
      this.initSidebar();
    }
  }
}
</script>

<style lang="css">
  .nav-link {
    cursor:pointer;
  }
  .ivu-icon-adt:before{
    position: absolute;
    top: 14px;
    left: 17px;
    width: 16px;
    height: 16px;
  }
  .ivu-icon-car:before{
    content: url(../../static/img/navbar/car.png);
  }
  .ivu-icon-company:before{
    content: url(../../static/img/navbar/gsxx.png);
  }
  .ivu-icon-tech:before{
    content: url(../../static/img/navbar/tech_vue.png);
  }
  .ivu-icon-home1:before{
    content: url(/static/img/navbar/home.png);
  }
  .ivu-icon-recommend:before{
    content: url(../../static/img/navbar/recommend.png);
  }
  .ivu-icon-warning:before{
    content: url(../../static/img/navbar/warning.png);
  }
  .ivu-icon-invest:before{
    content: url(../../static/img/navbar/invest.png);
  }
  .ivu-icon-policy:before{
    content: url(../../static/img/navbar/policy.png);
  }
  .ivu-icon-myconcern:before{
    content: url(../../static/img/navbar/myconcern.png);
  }

  .ivu-icon-credit:before{
    content: url(../../static/img/navbar/qyxy.png);
  }
  .ivu-icon-investment:before{
    content: url(../../static/img/navbar/trz.png);
  }
  .ivu-icon-skyminder:before{
    content: url(../../static/img/navbar/qqc.png);
  }
  .ivu-icon-enqaqc:before{
    content: url(../../static/img/navbar/qyzz.png);
  }
  .ivu-icon-judrisk:before{
    content: url(../../static/img/navbar/sfws.png);
  }
  .ivu-icon-ipr:before{
    content: url(../../static/img/navbar/zscq.png);
  }
  .ivu-icon-probid:before{
    content: url(../../static/img/navbar/ztb.png);
  }
  .ivu-icon-standard:before{
    content: url(../../static/img/navbar/bz.png);
  }
  .ivu-icon-bond:before{
    content: url(../../static/img/navbar/zqjj.png);
  }
  .ivu-icon-policy:before{
    content: url(../../static/img/navbar/zcfg.png);
  }
  .ivu-icon-reward:before{
    content: url(../../static/img/navbar/cgjl.png);
  }
  .ivu-icon-product:before{
    content: url(../../static/img/navbar/cpjg.png);
  }
  .ivu-icon-land:before{
    content: url(../../static/img/navbar/tdxx.png);
  }
  .ivu-icon-talent:before{
    content: url(../../static/img/navbar/rcxx.png);
  }
  .ivu-icon-recruit:before{
    content: url(../../static/img/navbar/zp.png);
  }
  .ivu-icon-fund:before{
    content: url(../../static/img/navbar/gjjjxm.png);
  }
  .ivu-icon-list:before{
    content: url(../../static/img/navbar/ssxx.png);
  }
  .ivu-icon-import:before{
    content: url(../../static/img/navbar/ppcx.png);
  }
  .ivu-icon-macroeconomy:before{
    content: url(../../static/img/navbar/hgjj.png);
  }
  .ivu-icon-monitor:before{
    content: url(../../static/img/navbar/wdjk.png);
  }
  .ivu-icon-webuser:before{
    content: url(../../static/img/navbar/webuser.png);
  }
  .ivu-icon-permission:before{
    content: url(../../static/img/navbar/permission.png);
  }
  .ivu-icon-case:before{
      content: url(../../static/img/navbar/alk.png);
  }
  .ivu-icon-park:before{
    content: url(../../static/img/navbar/cyq.png);
  }
  .ivu-icon-ecochina:before{
      content: url(../../static/img/navbar/gjjj.png);
  }
  .ivu-icon-policy:before{
      content: url(../../static/img/navbar/policy.png);
  }
  .ivu-icon-school:before{
      content: url(../../static/img/navbar/gx.png);
  }
  .ivu-icon-amac:before{
    content: url(../../static/img/navbar/smjj.png);
  }
  .ivu-icon-yearbook:before{
      content: url(../../static/img/navbar/tjnj.png);
  }
  .ivu-icon-onebeltoneroad:before{
      content: url(../../static/img/navbar/ydyl.png);
  }
  .ivu-icon-ecoworld:before{
      content: url(../../static/img/navbar/sjjj.png);
  }
  .ivu-icon-companyupdate:before{
    content: url(../../static/img/navbar/companyupdate.png);
  }
  .ivu-icon-apitimes:before{
    content: url(../../static/img/navbar/apitimes.png);
  }
  .ivu-icon-bgxz:before{
    content: url(../../static/img/navbar/bgxz_b.png);
  }
  .ivu-icon-research:before{
    content: url(../../static/img/navbar/research.png);
  }
  .ivu-icon-newsinfo:before{
    content: url(../../static/img/navbar/newsinfo.png);
  }
</style>



// WEBPACK FOOTER //
// Sidebar.vue?cf604458